import { Col, Row } from 'antd';
import React from 'react'
import { adjustmentsColumns, groupDifferencesByAction } from './helper';
import { renderModifiedGroup, renderRegularGroup } from './formHelper';
import { Card } from '../../common/UIComponents';

export const AdjustmentsDetails = ({data}) => {

  const renderEntireGroup = (changes, title, type, columns) => {
    if (!changes?.length) return null;
    return(
      <div>
      <h4
        className="ant-typography ant-typography-md font-medium mb-3"
        style={{ textAlign: "left", fontSize: "16px" }}
      >
        {title}
      </h4>
      <Card
      style={{
        background: '#fff',
        borderRadius: '8px',
        boxShadow: '0 2px 8px rgba(0,0,0,0.09)',
      }}
      >
        {renderRegularGroup(changes, title, type, columns)}
      </Card>
      </div>
    )
  }

  const renderDetails = () => {
    const adjustmentsData = data?.difference[0]?.adjustments ?? [];
    const incomingAction = data?.difference[0]?.adjustments?.[0]?.action;  
    const groupedDifferences = groupDifferencesByAction({ action: incomingAction, difference: adjustmentsData });
    const incomingEntry = adjustmentsData[0]?.new_value ? "New Entry" : "Old Entry";
    const showDataOrNot = 
    (
      !_.isEmpty(adjustmentsData[0]?.old_value) && 
      Object.values(adjustmentsData[0]?.old_value).some(value => value !== null)
    ) || 
    !_.isEmpty(adjustmentsData[0]?.new_value);
      return (
      showDataOrNot && (
      <div className="mt-6">
          <h4 className="ant-typography ant-typography-md font-medium mb-3" style={{ textAlign: 'left', fontSize: '18px' }}>
              <span style={{ fontSize: '20px', color: '#395484' }}>Adjustments</span>
              <div className="mt-6">
                  {renderEntireGroup(groupedDifferences.REMOVED, 'Deleted Entry', 'REMOVED', adjustmentsColumns)}
                  {renderEntireGroup(groupedDifferences.ADDED, incomingEntry, 'ADDED', adjustmentsColumns)}
                  {renderModifiedGroup(groupedDifferences.MODIFIED,adjustmentsColumns, "adjustments")}
              </div>
          </h4>
      </div>
      )
    )
  }

  return (
    <Row gutter={[16, 32]}>
      <Col span={24}>{renderDetails()}</Col>
    </Row>
  )
}